<template>
  <div class="file-explorer-mobile">
    <v-subheader v-if="!folders.length && !files.length && !loadingError && !notInicialized && !notInicializedSalesforce">Esta pasta está vazia</v-subheader>
    <template v-if="folders.length">
      <v-subheader class="pa-2" style="background-color: var(--v-subHeaderBackground-base);">Pastas</v-subheader>
      <v-divider/>
      <template v-for="(folder, index) in folders">
        <Folder :allowDelete="allowDelete" :key="`folder-${index}`" :item="folder" @click="forward(index)"  @informations="informations"
                @showAccessPermission="showAccessPermission" @showNotification="showNotification" @delete="deleteItem" @rename="rename"/>
      </template>
    </template>
  </div>
</template>

<script>
import Folder from '@/components/access-permission-explorer/Folder.vue';

export default {
  name: 'GenericFileExplorer',
  components: {
    Folder,
  },
  props: {
    folders: {
      type: Array,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    loadingError: {
      type: Boolean,
      required: true,
    },
    notInicialized: {
      type: Boolean,
      required: true,
    },
    notInicializedSalesforce: {
      type: Boolean,
      required: true,
    },
    allowCreate: {
      type: Boolean,
      required: true,
    },
    allowUpload: {
      type: Boolean,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    showingBottomFab: false,
  }),
  methods: {
    informations(item) {
      this.$emit('informations', item);
    },
    showAccessPermission(item) {
      this.$emit('showAccessPermission', item);
    },
    showNotification(item) {
      this.$emit('showNotification', item);
    },
    forward(index) {
      this.$emit('forward', index);
    },
    download(file, files) {
      this.$emit('download', file, files);
    },
    deleteItem(item) {
      this.$emit('delete', item);
    },
    rename(item) {
      this.$emit('rename', item);
    },
    hasFiles() {
      return this.files.length > 1;
    },
  },
};
</script>

<style lang="scss">

.file-explorer-mobile {
  padding-bottom: 100px;
}

.v-avatar {
  margin-left: 0;
}

.v-list-item {
  padding: 0;
}
</style>
